import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

import ApplyBtn from "../Components/ApplyBtn";
import MoreBtn from "../Components/MoreBtn";
import Layout from "../Layout/Layout";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";

import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../Layout/Pagination.jsx";
import AlarmApply from "../Modals/AlarmApply.jsx";
import Rankings from "../Modals/Rankings";
import { postJson } from "../Utils/apiUtils.js";
import { showToast } from "../Utils/variables.js";

const formatToday = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateValue = (value) => {
  if (!value) {
    return "";
  }

  if (value instanceof Date) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return String(value).slice(0, 10);
};

const formatDisplayDate = (value) => String(value ?? "").replaceAll("-", ".");

const getProgressStatus = (startTime, endTime) => {
  const today = formatToday();
  const startDate = formatDateValue(startTime);
  const endDate = formatDateValue(endTime);

  if (!startDate || !endDate) {
    return "";
  }

  if (today < startDate) {
    return "진행전";
  }

  if (today > endDate) {
    return "종료";
  }

  return "진행중";
};

const EventManageContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [total_event, setTotal_event] = useState(0);
  const [event_list, setEvent_list] = useState([]);

  const [page, setPage] = useState(1);
  const offset = 10;
  const [searchTitle, setSearchTitle] = useState("");
  const [seasonId, setSeasonId] = useState(null);

  const [clickRankings, setClickRankings] = useState(false);
  const [id, setId] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [eventPeriod, setEventPeriod] = useState("");

  const [clickDelete, setClickDelete] = useState(false);
  const [clickInput, setClickInput] = useState(false);
  const lastEventRequestKey = useRef(null);

  const getEventList = async () => {
    try {
      const body = {
        page: page,
        offset: offset,
        searchTitle: searchTitle,
      };

      const data = await postJson("/dashboard/event/getList", body, navigate);

      if (data.code === 200) {
        setTotal_event(data.data.count);
        setEvent_list(data.data.rows);
      }
    } catch (error) {
      console.log("이벤트대회 리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const handleDeleteEvent = async (seasonId) => {
    try {
      const body = { seasonId };

      const data = await postJson("/dashboard/event/delete", body, navigate);

      if (data.code === 200) {
        setClickDelete(false);
        showToast("이벤트 대회가 삭제되었습니다.", "success");

        const nextPage = event_list.length === 1 && page > 1 ? page - 1 : page;

        if (nextPage !== page) {
          setPage(nextPage);
          return;
        }

        lastEventRequestKey.current = null;
        getEventList();
      }
    } catch (error) {
      console.log("이벤트대회 삭제 중 에러:", error);
      throw error;
    }
  };

  const handleClickRankingBtn = (id, title, startTime, endTime) => {
    setClickRankings(true);
    setId(id);
    setEventTitle(title);
    setEventPeriod(
      `${formatDisplayDate(startTime)} ~ ${formatDisplayDate(endTime)}`
    );
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ page });

    if (lastEventRequestKey.current === requestKey) {
      return;
    }

    lastEventRequestKey.current = requestKey;
    getEventList();
  }, [page]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("이벤트 대회가 등록되었습니다.", "success");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div>
      {clickRankings && (
        <Rankings
          title="랭킹 간략히 보기"
          infotext="이벤트 대회는 기간 내 누적 걸음 수로 산정합니다."
          contestType="이벤트 대회"
          contestTitle={eventTitle}
          contestPeriod={eventPeriod}
          ourcontestType={0}
          id={id}
          handleClickX={() => setClickRankings(false)}
        />
      )}
      {clickDelete && (
        <AlarmApply
          title="항목을 삭제하시겠습니까?"
          subtitle="삭제하면 앱과 대시보드 내에서 해당 데이터가 영구적으로 사라집니다."
          handleApply={() => handleDeleteEvent(seasonId)}
          handleClickX={() => setClickDelete(false)}
        />
      )}
      {/* 이벤트 대회 관리 박스 */}
      <EventBox>
        <div className="title-in-box">이벤트 대회 관리</div>
        {/* 검색창 | 드롭다운 옵션 | 등록하기 버튼 */}
        <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{ boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "" }}
          >
            <input
              type="text"
              placeholder="대회명"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getEventList();
                }
              }}
            />
            <IconSearch style={{ cursor: "pointer" }} onClick={getEventList} />
          </div>

          <div style={{ display: "flex", marginLeft: "auto" }}>
            {/* 등록하기 버튼 */}
            <ApplyBtn addr="/event/apply" />
          </div>
        </div>

        {/* 전체 이벤트 대회 건수 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "30px", color: "#000000" }}
        >
          전체 {total_event?.toLocaleString()}건
        </div>

        {/* 이벤트 대회 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns:
                "100px 140px 300px 120px 220px 220px 140px 260px",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">대회 이미지</p>
            <p className="leftalign">대회명</p>
            <p className="leftalign">진행 상태</p>
            <p className="leftalign">대회 기간</p>
            <p className="leftalign">등록일</p>
          </div>

          {/* 데이터 */}
          {event_list.slice(0, 10).map((data) => (
            <EventData
              key={data.rownum}
              rownum={data.rownum}
              image={data.image}
              title={data.title}
              startTime={data.startTime}
              endTime={data.endTime}
              regTime={data.regTime}
              handleClickRankingBtn={handleClickRankingBtn}
              seasonId={data.seasonId}
              setClickDelete={setClickDelete}
              setSeasonId={setSeasonId}
            />
          ))}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={total_event === 0 ? 1 : Math.ceil(total_event / 10)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </EventBox>
    </div>
  );
};

const EventData = ({
  rownum,
  image,
  title,
  startTime,
  endTime,
  regTime,
  handleClickRankingBtn,
  seasonId,
  setClickDelete,
  setSeasonId,
}) => {
  const progressStatus = getProgressStatus(startTime, endTime);

  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns: "100px 140px 300px 120px 220px 220px 290px 58px 52px",
      }}
    >
      <p className="center">{rownum?.toLocaleString()}</p>
      <div className="leftalign">
        <div
          style={{ width: "112px", height: "44px", backgroundColor: "#d9d9d9" }}
        >
          {image ? (
            <img
              style={{ width: "100%", height: "100%" }}
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${image}`}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{title}</p>
      </div>
      <p className="leftalign">{progressStatus}</p>
      <p className="leftalign">{startTime + " ~ " + endTime}</p>
      <p className="leftalign">{regTime}</p>
      <div />
      <div className="center">
        {progressStatus === "종료" && (
          <div
            className="blueBorderBtn-58x39 center"
            onClick={() =>
              handleClickRankingBtn(seasonId, title, startTime, endTime)
            }
          >
            랭킹
          </div>
        )}
      </div>
      <div className="center">
        <MoreBtn
          option1="수정"
          option2="삭제"
          option1Addr={`/event/edit/${seasonId}`}
          optionClickDelete={() => {
            setSeasonId(seasonId);
            setClickDelete(true);
          }}
        />
      </div>
    </div>
  );
};

const EventBox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 30px;
`;

const EventManage = () => {
  return <Layout page={<EventManageContent />} />;
};

export default EventManage;
